<template>
  <div>
    <div
      class="ShopCart__cartPopper"
      v-tippy="{
        theme: 'wika light tooltip tooltip-bottom',
        interactive: true,
        reactive: true,
        placement: 'right',
        flip: false,
        animation: 'shift-away',
        animateFill: false,
        arrow: false,
        distance: 11,
        zIndex: 10000,
        html: '#addToCartPopperContent',
        trigger: 'manuel'
      }"
      ref="addToCartTippy"
      @init="initAddToCartTippy"
    ></div>
    <div id="addToCartPopperContent" class="ShopCart__popperContent">
      <div class="columns is-mobile is-multiline">
        <div class="ShopCart__cartItem column is-full">
          <strong class="ShopCart__headline">{{ config.headline }}:</strong>
          <Button
            class="ShopCart__close"
            isClose
            colour="white"
            @close="closePopper"
          />
          <div class="columns is-mobile">
            <div class="column is-one-third">
              <img :src="item.thumbnail" :alt="item.title" />
            </div>
            <div class="ShopCart__priceBox column is-two-thirds">
              <strong class="ShopCart__title">{{ item.title }}</strong>
              <div>{{ item.name }}</div>
              <p class="ShopCart__heading">
                {{ config.itemNumber }}:
                {{
                  typeof item !== "undefined" &&
                  typeof item.id !== "undefined" &&
                  !item.id.includes("none_")
                    ? item.id
                    : config.noArtNoAvailableText
                }}
              </p>
              <div>
                {{ config.pricePerItem }}:
                <span v-html="formatMoney(item.pricesingle)"></span>
              </div>
              <div class="ShopCart__labelBox">
                <div class="ShopCart__label">
                  {{ config.quantity }}: {{ item.quantity }}
                </div>
                <div class="ShopCart__label">
                  <span v-html="formatMoney(item.pricesum)"></span>
                </div>
              </div>
              <div class="ShopCart__tax">
                {{ config.tax }} &amp;
                <a :href="config.shippingUrl">
                  {{ config.shippingText }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div
          class="ShopCart__cartTotal column is-offset-one-third is-two-thirds"
        >
          <Button
            colour="blue"
            :text="config.buttonText"
            :isLink="true"
            :href="config.shopCartUrl"
          >
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../Button/Button";

export default {
  name: "ShopCartPopper",
  components: {
    Button
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    },
    isPopperOpen: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isPopperOpen: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        newValue === true ? this.openPopper() : this.closePopper();
      }
    }
  },
  methods: {
    initAddToCartTippy(tippy) {
      tippy.popper.id = "addToCartPopper";
    },
    openPopper() {
      this.$refs.addToCartTippy._tippy.show();
    },
    closePopper() {
      this.$refs.addToCartTippy._tippy.hide();
    },
    formatMoney(value) {
      if (value) {
        const price = value.toString().replace(".", ",");
        return accounting.formatMoney(
          parseFloat(price.replace(".", "").replace(",", ".")),
          {
            symbol: this.config.currency,
            format: this.config.currencyPosition,
            decimal: this.config.decimalSep,
            thousand: this.config.thousandSep,
            precision: this.config.precisionValue
          }
        );
      }
    }
  }
};
</script>
